module.exports = __webpack_public_path__ + "img/close-yellow-button.bb385a29.svg";